import { IS_PROD } from "../util/stage"
import { RouteName } from "./route"

export const STAKING_INFO = {
    title: "Staking Reward",
    description: "Stake your tokens to receive rewards in PERP and a portion of transaction fees from the exchange.",
    docUrl: "https://docs.perp.fi/getting-started/staking",
    rewardUrl: IS_PROD ? "https://staking.perp.exchange/" : "https://rinkeby-incentive.perp.exchange/",
    imageUrl: "/images/banner-staking.png",
    releaseTime: "2022-01-01T00:00+08:00",
}

export const ONBOARDING_INFO = {
    title: "Onboarding Program",
    description:
        "Welcome aboard! The onboarding program is the key to join the PERP world, finish all the 3 steps in this program and get rewarded!",
    docUrl: "https://onboarding.perp.fi/",
    rewardUrl: RouteName.ONBOARDING,
    imageUrl: "/images/banner-onboarding.png",
    releaseTime: "2022-01-01T00:00+08:00",
    buttonText: "GO",
}

export const GAS_REBATE_INFO = {
    title: "Perp v2 Gas Rebate Program",
    description:
        "The Gas Rebate Program has concluded. We will review the program and decide whether or not to continue in the future.",
    docUrl: "https://blog.perp.fi/introducing-gas-rebate-program-for-perp-v2-fd045c17e920",
    rewardUrl: RouteName.GAS_REBATE,
    imageUrl: "/images/banner-gas-rebate.png",
    releaseTime: "2022-01-05T00:00+08:00",
}

export const LIQUIDITY_MINING_INFO = {
    title: "Perp v2 Pool Party",
    description:
        "Earn PERP and OP by providing liquidity on Perp v2! The more tx fees you earn proportionately, the more rewards you earn. You can also provide liquidity with leverage.",
    docUrl: "https://blog.perp.fi/pool-party-liquidity-mining-in-op-summer-40edd1981340",
    rewardUrl: RouteName.LIQUIDITY_MINING_LIST,
    imageUrl: "/images/banner-perp-v2-pool-party.png",
    releaseTime: "2022-01-12T00:00+08:00",
}

export const TESTNET_TRADING_COMPETITION_INFO = {
    title: "Testnet Competition Rewards",
    description:
        "Reach your target volume on Perp v2 mainnet before 2022/2/14 to claim your rewards from the testnet trading competition.",
    docUrl: "https://blog.perp.fi/recap-of-the-perpfect-game-perp-v2-testnet-trading-competition-ae0ff36b19ef",
    rewardUrl: RouteName.TESTNET_COMPETITION,
    imageUrl: "/images/banner-testnet-competition.png",
    releaseTime: "2022-01-18T12:00+08:00",
}

export const ONBOARDING_PROGRAM = {
    title: "Onboarding Program",
    description:
        "Welcome aboard! The onboarding program is the key to join the PERP world, get as many points as you can to win 200 USDC reward!",
    rewardUrl: RouteName.ONBOARDING_PROGRAM,
    docUrl: "https://medium.com/@perpetualprotocol/onboarding-v2-876ff238b1fc",
    imageUrl: "/images/banner_onboarding_part2.png",
    releaseTime: "2022-04-08T15:00+08:00", //TODO
    whitelistBattleEndTime: "2022-05-06T15:00+08:00",
    buttonText: "GO",
    isWhiteListBattleEnd: () => Date.now() > Date.parse(ONBOARDING_PROGRAM.whitelistBattleEndTime),
}

export const REWARD_CARD_INFOS = [
    LIQUIDITY_MINING_INFO,
    STAKING_INFO,
    GAS_REBATE_INFO,
    TESTNET_TRADING_COMPETITION_INFO,
    // NOTE: manually import due to the signup modal
    // ONBOARDING_PROGRAM,
]
